// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bascule "pilule" (segmented control). Valeurs reprises du selecteur de perimetre. */
.view-switch {
  display: inline-flex;
  align-self: flex-start;
  padding: 0.3rem;
  gap: 0.3rem;
  background: #f3f4f6;
  border-radius: 0.7rem;
}

.view-switch-btn {
  padding: 0.5rem 1.4rem;
  border: none;
  background: none;
  border-radius: 0.5rem;
  font-size: 1.3rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.view-switch-btn.is-active {
  background: #fff;
  color: #f97316;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/composants/ViewSwitch/ViewSwitch.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C","sourcesContent":["/* Bascule \"pilule\" (segmented control). Valeurs reprises du selecteur de perimetre. */\n.view-switch {\n  display: inline-flex;\n  align-self: flex-start;\n  padding: 0.3rem;\n  gap: 0.3rem;\n  background: #f3f4f6;\n  border-radius: 0.7rem;\n}\n\n.view-switch-btn {\n  padding: 0.5rem 1.4rem;\n  border: none;\n  background: none;\n  border-radius: 0.5rem;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.view-switch-btn.is-active {\n  background: #fff;\n  color: #f97316;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
